/* HF Fragrances : custom product page behaviour. No theme dependencies. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Deterministic pseudo random so a shopper sees the same numbers all day. */
  function seeded(seed) {
    var x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }
  function dayStamp() {
    var d = new Date();
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  var toastEl = null;
  var toastTimer = null;

  function toast(message, linkHtml) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'hf-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + message + '</span>' + (linkHtml || '');
    toastEl.setAttribute('data-open', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-open', 'false'); }, 4000);
  }

  function HFProduct(root) {
    this.root = root;
    this.form = $('[data-hf-form]', root);
    this.config = JSON.parse($('[data-hf-config]', root).textContent);
    this.variants = JSON.parse($('[data-hf-variants]', root).textContent);
    this.current = this.variants.filter(function (v) { return v.id === this.config.currentVariantId; }.bind(this))[0] || this.variants[0];
    this.urgencyTimer = null;

    this.initGallery();
    this.initOptions();
    this.initQuantity();
    this.initAccordions();
    this.initShare();
    this.initCart();
    this.initSocialProof();
    this.initSticky();
    this.recordRecentlyViewed();
    this.render();
  }

  /* ---------------------------------------------------------- gallery */
  HFProduct.prototype.initGallery = function () {
    var self = this;
    this.slides = $$('[data-hf-slide]', this.root);
    this.thumbs = $$('[data-hf-thumb]', this.root);

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { self.showMedia(thumb.getAttribute('data-media-id')); });
    });

    $$('[data-hf-thumb-arrow]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rail = $('[data-hf-thumb-rail]', self.root);
        if (!rail) return;
        var dir = btn.getAttribute('data-hf-thumb-arrow') === 'next' ? 1 : -1;
        if (window.matchMedia('(max-width: 989px)').matches) rail.scrollBy({ left: dir * 160, behavior: 'smooth' });
        else rail.scrollBy({ top: dir * 172, behavior: 'smooth' });
      });
    });
  };

  HFProduct.prototype.showMedia = function (mediaId) {
    if (!mediaId) return;
    this.slides.forEach(function (slide) {
      var match = slide.getAttribute('data-media-id') === String(mediaId);
      slide.setAttribute('data-active', match ? 'true' : 'false');
      if (!match) {
        var video = slide.querySelector('video');
        if (video && !video.paused) video.pause();
      }
    });
    this.thumbs.forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false');
    });
  };

  /* ---------------------------------------------------------- options */
  HFProduct.prototype.initOptions = function () {
    var self = this;
    $$('[data-hf-option-input]', this.root).forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(); });
    });
  };

  HFProduct.prototype.selectedOptions = function () {
    var values = [];
    $$('[data-hf-option-group]', this.root).forEach(function (group) {
      var checked = group.querySelector('input:checked');
      values.push(checked ? checked.value : null);
    });
    return values;
  };

  HFProduct.prototype.onOptionChange = function () {
    var chosen = this.selectedOptions();
    var match = this.variants.filter(function (v) {
      return chosen.every(function (value, i) { return value === null || v.options[i] === value; });
    })[0];

    this.current = match || null;
    this.render();

    if (match) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      if (match.featured_media_id) this.showMedia(match.featured_media_id);
    }
  };

  /* ----------------------------------------------------------- render */
  HFProduct.prototype.render = function () {
    var v = this.current;
    var self = this;
    var idInput = $('[data-hf-variant-id]', this.root);
    var priceNow = $('[data-hf-price-now]', this.root);
    var priceWas = $('[data-hf-price-was]', this.root);
    var priceSave = $('[data-hf-price-save]', this.root);
    var stock = $('[data-hf-stock]', this.root);
    var addBtn = $('[data-hf-add]', this.root);
    var payment = $('[data-hf-payment]', this.root);
    var stickyPrice = $('[data-hf-sticky-price]');
    var waBtn = $('[data-hf-whatsapp]', this.root);

    $$('[data-hf-option-group]', this.root).forEach(function (group, index) {
      $$('input', group).forEach(function (input) {
        var label = group.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var possible = self.variants.some(function (variant) {
          return variant.options[index] === input.value && variant.available;
        });
        label.setAttribute('data-soldout', possible ? 'false' : 'true');
      });
      var checked = group.querySelector('input:checked');
      var out = group.parentNode.querySelector('[data-hf-option-selected]');
      if (out && checked) out.textContent = checked.value;
    });

    if (!v) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      if (stock) { stock.setAttribute('data-state', 'out'); $('[data-hf-stock-text]', stock).textContent = 'This combination is not available'; }
      if (payment) payment.style.display = 'none';
      this.renderUrgency(null);
      return;
    }

    if (idInput) idInput.value = v.id;
    if (priceNow) priceNow.textContent = v.price_formatted;

    if (priceWas) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceWas.textContent = v.compare_formatted;
        priceWas.style.display = '';
        if (priceSave) {
          var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          priceSave.textContent = 'Save ' + pct + '%';
          priceSave.style.display = '';
        }
      } else {
        priceWas.style.display = 'none';
        if (priceSave) priceSave.style.display = 'none';
      }
    }

    if (stock) {
      var text = $('[data-hf-stock-text]', stock);
      stock.setAttribute('data-state', v.available ? 'in' : 'out');
      text.textContent = v.available ? 'In stock and ready to ship' : 'Sold out';
    }

    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? this.config.addLabel : 'Sold out';
    }
    if (payment) payment.style.display = v.available ? '' : 'none';
    if (stickyPrice) stickyPrice.textContent = v.price_formatted;

    if (waBtn) {
      var msg = this.config.waMessage
        .replace('{title}', this.config.productTitle + (v.public_title ? ' (' + v.public_title + ')' : ''))
        .replace('{url}', this.config.productUrl + '?variant=' + v.id);
      waBtn.href = 'https://wa.me/' + this.config.waNumber + '?text=' + encodeURIComponent(msg);
    }

    this.renderUrgency(v);
  };

  /* ---------------------------------------------------------- urgency */
  HFProduct.prototype.renderUrgency = function (v) {
    var box = $('[data-hf-urgency]', this.root);
    if (!box) return;

    clearInterval(this.urgencyTimer);

    if (!v || !v.available) { box.style.display = 'none'; return; }
    box.style.display = '';

    var cfg = this.config.urgency;
    var countEl = $('[data-hf-urgency-count]', box);
    var fillEl = $('[data-hf-urgency-fill]', box);
    var soldEl = $('[data-hf-urgency-sold]', box);
    var left;

    /* Real inventory wins whenever Shopify is tracking it. */
    if (v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= cfg.max) {
      left = v.inventory_quantity;
    } else {
      var span = Math.max(1, cfg.max - cfg.min);
      left = cfg.min + Math.floor(seeded(v.id + dayStamp()) * (span + 1));
    }

    var target = Math.max(1, left);

    /* The bar fills the part already taken, so a low number reads as nearly gone. */
    var claimed = Math.round((1 - target / cfg.max) * 100);
    claimed = Math.max(45, Math.min(94, claimed));

    if (soldEl) soldEl.textContent = claimed + '% ' + (cfg.soldLabel || 'claimed');

    if (countEl) {
      var from = target + 3;
      countEl.textContent = from;
      var step = 0;
      this.urgencyTimer = setInterval(function () {
        step += 1;
        var value = from - step;
        countEl.textContent = value;
        if (value <= target) clearInterval(this.urgencyTimer);
      }.bind(this), 220);
    }

    if (fillEl) {
      fillEl.style.width = '0%';
      setTimeout(function () { fillEl.style.width = claimed + '%'; }, 150);
    }
  };

  /* ----------------------------------------------------- social proof */
  HFProduct.prototype.initSocialProof = function () {
    var box = $('[data-hf-social]', this.root);
    if (!box) return;

    var cfg = this.config.social;
    var names = (cfg.names || '').split(',').map(function (n) { return n.trim(); }).filter(Boolean);
    var images = cfg.images || [];
    if (names.length < 3) { box.style.display = 'none'; return; }

    var facesEl = $('[data-hf-social-faces]', box);
    var namesEl = $('[data-hf-social-names]', box);
    var countEl = $('[data-hf-social-count]', box);
    var palette = ['#a9822f', '#14110f', '#1f7a54', '#7a4b2a', '#4a5568', '#8a3b3b'];

    function pick(n) {
      var pool = names.slice();
      var out = [];
      while (out.length < n && pool.length) {
        out.push(pool.splice(Math.floor(Math.random() * pool.length), 1)[0]);
      }
      return out;
    }

    function paint(trio) {
      if (namesEl) namesEl.textContent = trio.join(', ');
      if (!facesEl) return;
      facesEl.innerHTML = '';
      trio.forEach(function (name, i) {
        var face = document.createElement('span');
        face.className = 'hf-social__face';
        if (images.length) {
          var img = document.createElement('img');
          img.src = images[Math.floor(Math.random() * images.length)];
          img.alt = '';
          img.loading = 'lazy';
          face.appendChild(img);
        } else {
          face.style.background = palette[(name.charCodeAt(0) + i) % palette.length];
          face.textContent = name.charAt(0).toUpperCase();
        }
        facesEl.appendChild(face);
      });
    }

    paint(pick(3));

    var base = cfg.baseCount || 5000;
    var drift = Math.floor(seeded(dayStamp()) * (cfg.dailyDrift || 1000));
    var target = base + drift;
    var value = Math.max(0, target - 60);

    function writeCount() {
      if (countEl) countEl.textContent = value.toLocaleString('en-US');
    }
    writeCount();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      value = target;
      writeCount();
      return;
    }

    var climb = setInterval(function () {
      value += Math.max(1, Math.round((target - value) / 8));
      if (value >= target) { value = target; clearInterval(climb); }
      writeCount();
    }, 70);

    setInterval(function () {
      box.setAttribute('data-swap', 'true');
      setTimeout(function () {
        paint(pick(3));
        box.setAttribute('data-swap', 'false');
      }, 420);
    }, cfg.rotateMs || 4000);

    setInterval(function () {
      value += 1;
      writeCount();
    }, cfg.tickMs || 9000);
  };

  /* --------------------------------------------------------- quantity */
  HFProduct.prototype.initQuantity = function () {
    var input = $('[data-hf-qty-input]', this.root);
    if (!input) return;
    $$('[data-hf-qty-step]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-hf-qty-step'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  /* ------------------------------------------------------- accordions */
  HFProduct.prototype.initAccordions = function () {
    $$('[data-hf-acc-head]', this.root).forEach(function (head) {
      head.addEventListener('click', function () {
        var panel = document.getElementById(head.getAttribute('aria-controls'));
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.setAttribute('data-open', open ? 'false' : 'true');
      });
    });
  };

  /* ------------------------------------------------------------ share */
  HFProduct.prototype.initShare = function () {
    var self = this;
    var btn = $('[data-hf-share]', this.root);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) navigator.share({ title: self.config.productTitle, url: url }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
    });
  };

  /* ------------------------------------------------------------- cart */
  HFProduct.prototype.initCart = function () {
    var self = this;
    if (!this.form) return;

    this.form.addEventListener('submit', function (event) {
      if (!self.config.ajaxCart) return;
      event.preventDefault();

      var btn = $('[data-hf-add]', self.root);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(self.form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) { toast(result.data.description || 'Could not add this item'); return; }
          toast('Added to cart', ' <a href="/cart">View cart</a>');
          document.dispatchEvent(new CustomEvent('hf:cart:added', { detail: result.data }));
          self.refreshCartCount();
        })
        .catch(function () { toast('Something went wrong. Please try again.'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  };

  HFProduct.prototype.refreshCartCount = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        $$('[data-cart-count], .cart-count-bubble span:first-child, #cart-icon-bubble .cart-count-bubble span').forEach(function (node) {
          node.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('hf:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  };

  /* ------------------------------------------------------- sticky bar */
  HFProduct.prototype.initSticky = function () {
    var bar = $('[data-hf-sticky]');
    var buy = $('[data-hf-buy-block]', this.root);
    if (!bar || !buy) return;

    var self = this;
    var stickyAdd = $('[data-hf-sticky-add]', bar);
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!self.form) return;
        if (self.form.requestSubmit) self.form.requestSubmit();
        else self.form.submit();
      });
    }

    /* Show only once the buy block has scrolled up out of view, never
       while any part of it is still on screen. */
    function update() {
      var rect = buy.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      bar.setAttribute('data-show', scrolledPast ? 'true' : 'false');
    }

    update();

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });
  };

  /* --------------------------------------------------- recently viewed */
  HFProduct.prototype.recordRecentlyViewed = function () {
    try {
      var key = 'hf:recently-viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      var id = this.config.productId;
      list = list.filter(function (item) { return item !== id; });
      list.unshift(id);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* storage disabled */ }
  };

  function renderRecentlyViewed() {
    var holder = $('[data-hf-recently-viewed]');
    if (!holder) return;

    var current = holder.getAttribute('data-current-id');
    var limit = parseInt(holder.getAttribute('data-limit'), 10) || 4;
    var sectionId = holder.getAttribute('data-section-id');
    var ids;

    try { ids = JSON.parse(localStorage.getItem('hf:recently-viewed') || '[]'); }
    catch (e) { return; }

    ids = ids.filter(function (id) { return String(id) !== String(current); }).slice(0, limit);
    if (!ids.length) return;

    var query = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    fetch('/search?type=product&q=' + encodeURIComponent(query) + '&section_id=' + sectionId)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = parsed.querySelector('[data-hf-rv-grid]');
        if (grid && grid.children.length) {
          holder.innerHTML = grid.parentNode.innerHTML;
          holder.hidden = false;
        }
      })
      .catch(function () {});
  }

  function init() {
    $$('[data-hf-pdp]').forEach(function (root) {
      if (root.hfReady) return;
      root.hfReady = true;
      try { new HFProduct(root); } catch (e) { console.warn('HF product init failed', e); }
    });
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
